namespace TabAurous.ProductDevelopment {
    export interface SpecSheetImportForm {
        FileName: Serenity.ImageUploadEditor;
    }

    export class SpecSheetImportForm extends Serenity.PrefixedContext {
        static formKey = 'ProductDevelopment.SpecSheetImport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SpecSheetImportForm.init)  {
                SpecSheetImportForm.init = true;

                var s = Serenity;
                var w0 = s.ImageUploadEditor;

                Q.initFormType(SpecSheetImportForm, [
                    'FileName', w0
                ]);
            }
        }
    }
}
